<microempresario-header></microempresario-header>
<div class="body pt-4">
  <div class="container pb-4 px-3">
    <div class="row wrapperSolicitud__slider g-0">
      <div class="col-12 col-lg-7 wrapperSolicitud__slider__left order-2 order-lg-1 mb-3 mb-lg-0">
        <div class="ratio ratio-21x9">
          @if (!isFile) {
            @if (youtubeConsent) {
            <iframe class="videobkg-1 rounded p-0"
              [src]="urlVideoFormulario | safe" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
            } @else {
            <div class="videobkg-1 rounded p-0 d-flex align-items-center justify-content-center bg-light text-center px-3">
              <p class="mb-0 small">Active las cookies de YouTube para ver este video.</p>
            </div>
            }
          }
          @if (isFile) {
            @if (youtubeConsent) {
            <iframe class="videobkg-1 rounded p-0"
              [src]="urlVideoDocumentos | safe" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
            } @else {
            <div class="videobkg-1 rounded p-0 d-flex align-items-center justify-content-center bg-light text-center px-3">
              <p class="mb-0 small">Active las cookies de YouTube para ver este video.</p>
            </div>
            }
          }
        </div>
      </div>
      <div class="col-12 col-lg-5 wrapperSolicitud__slider__right px-3 order-1 order-lg-2">
        <h1>Formulario de solicitud</h1>
        <p>
          Si necesitas ayuda para diligenciar el formulario, por favor mira el video explicativo. Si prefieres, también puedes avanzar y completar el formulario por tu cuenta.
        </p>
      </div>
    </div>
  </div>
  @if (!isFile && isNatural) {
    <solicitud-natural-form (event)="changeToFiles($event)"></solicitud-natural-form>
  }
  @if (!isFile && !isNatural) {
    <solicitud-juridica-form (event)="changeToFiles($event)"></solicitud-juridica-form>
  }
  @if (isFile) {
    <files-form (event)="changeToForm($event)" [isExpress]="isExpress" [idEstadoSolicitud]="idEstadoSolicitud"></files-form>
  }
  <div class="text-center container-fluid text-ligth mt-2 d-none d-xl-block">
    Campos obligatorios a diligenciar*
  </div>
  <div class="footer-body"></div>
</div>
